const nl = {
    common: {
        history: "historische versie"
    }
};
export default nl;



// WEBPACK FOOTER //
// ./src/i18n/langs/nl.js